/**
 * @typedef {Object} BookingDateViewModelType
 * @property {number} id - Unique identifier (of a booking in the same group)
 * @property {string} date - The date of the booking without any time data
 * @property {string} status - The raw booking status (e.g. "unfilled"), maps to a
 *   BookingStatusLabelType via BookingStatusMap
 */

/**
 * @class
 */
export default class BookingDateViewModel {
  /**
   * Create a new BookingDateViewModel.
   * @param {...BookingDateViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.date = params.date
    this.status = params.status
  }
}
